exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".1942{font-family:\"1942\"}.elite{font-family:Special Elite}.levo{text-align:left}.desno{text-align:right}.centar,.center{text-align:center}.bold{font-weight:700}.pocetno-veliko:first-letter{text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/10-tipografija.css
// module id = 24
// module chunks = 0